/* eslint-disable semi */

// カスタムバリデーションルール用のユーティリティ群

/**
 * メッセージテンプレートを取得する
 * @param {*} rule
 * @param {*} options
 */
export function getMessageTemplate (rule, options) {
  const type = rule.type;
  if (type in options.messages.types) {
    return options.messages.types[type];
  } else {
    return options.messages.default;
  }
}



// WEBPACK FOOTER //
// ./src/core/rules/utils.js